import { render } from "./ReportsCountriesLegendItem.vue?vue&type=template&id=b8c6140a&ts=true"
import script from "./ReportsCountriesLegendItem.vue?vue&type=script&lang=ts"
export * from "./ReportsCountriesLegendItem.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/apps/myparcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__